<template>
  <v-form v-model="registerForm.valid" ref="registerForm">
    <v-row>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="登录名"
          placeholder="建议以企业统一社会信用代码作为登录名"
          clearable
          v-model="registerForm.loginname"
          :rules="registerForm.loginnameRules"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="用户昵称"
          clearable
          v-model="registerForm.username"
          :rules="registerForm.usernameRules"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="统一社会信用代码"
          clearable
          v-model="registerForm.orgCode"
          :rules="registerForm.orgCodeRules"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-radio-group
          v-model="registerForm.registerType"
          :rules="registerForm.registerTypeRules"
          row
        >
          <v-radio
            v-for="item in registerForm.registerTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="6">
        <el-cascader
          placeholder="请选择行政区划"
          size="large"
          :options="regionDataList"
          v-model="selectedOptions"
          @change="handleRegionChange"
        >
        </el-cascader>
      </v-col>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="密码"
          type="password"
          clearable
          v-model="registerForm.password"
          :rules="registerForm.passwordRules"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="确认密码"
          type="password"
          clearable
          v-model="registerForm.password2"
          :rules="
            registerForm.password2Rules.concat(validateRegisterConfirmPassword)
          "
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          @input="setVal"
          label="验证码（不区分大小写）"
          clearable
          v-model="registerForm.registerCaptcha"
          :rules="
            registerForm.registerCaptchaRules.concat(validateRegisterCaptcha)
          "
        ></v-text-field>
        <Captcha @setCaptchaNum="setCaptchaNum"></Captcha>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { regionDataPlus } from "element-china-area-data";
import Captcha from "../Captcha";
import api from "../../../http/apis/apis";
import { createNamespacedHelpers } from "vuex";
const {
  mapActions: userActions,
  mapState: userState,
  mapMutations: userMutations,
} = createNamespacedHelpers("user");
export default {
  props: ["registerForm"],
  data() {
    return {
      captchaStr: "",
      options: regionDataPlus,
      selectedOptions: [],
      regionDataList: [],
    };
  },
  created() {
    this.getRegionList();
  },
  methods: {
    async getRegionList() {
      const { data } = await api.userApi.getRegionList();

      if (data.IsSuccessful) {
        // console.info("region data", this.regionDataList.children);
        data.ResultObj[0].children.forEach((item) => {
          let obj = {
            label: item.text,
            value: item.id,
            children: [],
          };

          if (item.children.length) {
            item.children.forEach((item2) => {
              let obj2 = {
                label: item2.text,
                value: item2.id,
                children: [],
              };
              if (item2.children.length) {
                item2.children.forEach((item3) => {
                  obj2.children.push({
                    label: item3.text,
                    value: item3.id,
                  });
                });
              } else {
                obj2 = {
                  label: item2.text,
                  value: item2.id,
                };
              }
              obj.children.push(obj2);
            });
          }
          this.regionDataList.push(obj);
        });
      }
    },
    handleRegionChange(value) {
      this.registerForm.areaCode = value[value.length - 1];
      console.info("got ac", this.registerForm.areaCode);
      this.$emit("setRegisterValue", this.registerForm);
    },
    validateRegisterCaptcha(val) {
     return val.toLowerCase() == this.captchaStr.toLowerCase() || "验证码错误";
    },
    validateRegisterConfirmPassword(val) {
      return val == this.registerForm.password || "两次密码不一致";
    },
    setCaptchaNum(val) {
      this.captchaStr = val;
    },
    setVal() {
      this.$emit("setRegisterValue", this.registerForm);
      this.$refs.registerForm.validate();
    },
  },
  components: {
    Captcha,
  },
};
</script>

<style>
</style>